import React, { useState } from "react";
import { Wrapper, ClickableLogo } from "../../index.styled";
import Footer from "../footer-v2";

const Catalog23IT = () => {
  const [authorized, setAuthorized] = useState(false);
  const [inputPassword, setInputPassword] = useState("");

  const correctPassword = "GZvault25"; // Change this to your desired password

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputPassword === correctPassword) {
      setAuthorized(true);
    } else {
      alert("Incorrect password. Please contact hey@grollz.com for access.");
    }
  };

  return (
    <Wrapper
      style={{
        position: "relative",
        maxWidth: "1500px",
        margin: "0 auto",
      }}
    >
      <ClickableLogo />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          marginTop: "0rem",
        }}
      >
        <h3>Catalog 2025</h3>
        {!authorized ? (
          <form onSubmit={handleSubmit} style={{ textAlign: "center" }}>
            <p>Catalog Password:</p>
            <input
              type="password"
              value={inputPassword}
              onChange={(e) => setInputPassword(e.target.value)}
              style={{ margin: "0.5rem", padding: "0.5rem" }}
            />
            <br />
            <button type="submit" style={{ padding: "0.5rem 1rem" }}>
              Enter
            </button>
            <p style={{ marginTop: "1rem", fontSize: "0.9rem" }}>
              Need access? Contact <a href="mailto:hey@grollz.com">hey@grollz.com</a>
            </p>
          </form>
        ) : (
          <iframe
            src="https://player.flipsnack.com?hash=RUE1QTdEODhCN0ErMXBsZ21wa3Z4bg=="
            width="100%"
            height="580"
            seamless="seamless"
            scrolling="no"
            frameBorder="0"
            allowFullScreen
            allow="autoplay; clipboard-read; clipboard-write"
          ></iframe>
        )}
      </div>
      <Footer />
    </Wrapper>
  );
};

export default Catalog23IT;
